import { useContext, VFC } from 'react';

import MarketplaceItemsContext from '@/contexts/MarketplaceItemsContext';

import MarketplaceItem from './MarketplaceItem';
import styles from './MarketplacePage.module.scss';

const RandomMarketplaceContents: VFC = () => {
  const { randomCreations } = useContext(MarketplaceItemsContext);

  return (
    <div className={styles.marketplaceContentsList}>
      {randomCreations.map((item) => (
        <div key={item.creationID} className={styles.marketPlaceItemContainer}>
          <MarketplaceItem saleItem={item} />
        </div>
      ))}
    </div>
  );
};

export default RandomMarketplaceContents;
